export default {
  UXTR01: "UXTR01",
  FWR30: "FWR30",
  FWR30v10: "FWR30v10",
};
